import { render, staticRenderFns } from "./PlaceOrderSideBar.vue?vue&type=template&id=527dbf31&"
import script from "./PlaceOrderSideBar.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports